import { Button, CustomDialog } from '../../../components';
import upscaleIcon from '../../../assets/icons/upscale.svg';
import { useState } from 'react';
import { TResponseImg } from '../../../utils/types/agrocraftArtisan';
import {
  useOverrideImageMutation,
  useUpscaleImageMutation,
} from '../../../services/agrocraftArtisan';
import { useAppDispatch } from '../../../storeHook';
import { showAlert } from '../../../reduxActions/alert';
import './index.scss';
import {
  CUSTOM_EVENTS,
  appLogEvent,
} from '../../../utils/analytics';
import { Tooltip } from '@mui/material';

type TProps = {
  img: TResponseImg;
  chatId: number;
  setIsScrollToLatest: React.Dispatch<
    React.SetStateAction<boolean>
  >;
};

export const ImageUpscale = ({
  img: { Content: img },
  chatId,
  setIsScrollToLatest,
}: TProps) => {
  const [open, setOpen] = useState(false);
  const [isOverride, setIsOverride] = useState(false);
  const dispatch = useAppDispatch();

  const [upscaleImage, { isLoading: isLoadingUpscale }] =
    useUpscaleImageMutation();
  const [overrideImage, { isLoading: isLoadingOverride }] =
    useOverrideImageMutation();

  const overrideImageAPI = (
    original_image_path: string,
    override_image_path: string
  ) => {
    setIsScrollToLatest(false);
    overrideImage({
      chatId,
      data: {
        original_image_path,
        override_image_path,
      },
    })
      .unwrap()
      .then(() => {
        setOpen(false);
        dispatch(
          showAlert({
            content:
              'Image Upscaled and overwritten successfully',
          })
        );
      })
      .catch(() => {});
  };

  const onBtnClick = (overRide?: boolean) => {
    appLogEvent(CUSTOM_EVENTS.IMAGE_UPSCALE, {
      overRide,
    });
    setIsOverride(overRide ? true : false);
    upscaleImage({
      upscale_size: 2,
      image_path: img.image_link,
    })
      .unwrap()
      .then((res) => {
        const updatedImagePath = res.updated_image_path;
        if (updatedImagePath) {
          if (overRide) {
            overrideImageAPI(
              img.image_link,
              updatedImagePath
            );
          } else {
            setOpen(false);
            dispatch(
              showAlert({
                content: 'Image Upscaled successfully',
              })
            );
            window.location.href = updatedImagePath;
          }
        } else {
          dispatch(
            showAlert({
              content:
                'Oops! An unexpected error occurred. Please try again later.',
              severity: 'error',
            })
          );
        }
      })
      .catch(() => {});
  };

  const isLoadingUpscaleAndOverride =
    isOverride && (isLoadingOverride || isLoadingUpscale);
  const isLoadingUpscaleAndDownload =
    !isOverride && isLoadingUpscale;
  const areBtnsDisabled =
    isLoadingOverride || isLoadingUpscale;

  return (
    <div>
      <Tooltip title="Upscale image resolution">
        <a
          onClick={() =>
            !img.is_image_overriden && setOpen(!open)
          }
          className={
            img.is_image_overriden ? 'disabled' : ''
          }>
          <img src={upscaleIcon} />
        </a>
      </Tooltip>
      <CustomDialog
        dialogTitle="Image Upscale"
        open={open}
        setOpen={setOpen}
        maxWidth="md"
        showActions={false}
        headerClass="popup-header">
        <section className="popup-content">
          <div className="content-box">
            <div>
              Current size: {img.width}x{img.height}
            </div>
            <div>Resolution: 72 dpi</div>
            <div className="disclaimer">
              The new image will be upscaled to 2x
            </div>
            <div>
              New size: {img.width * 2}x{img.height * 2}
            </div>
            <div>New Resolution: 300 dpi</div>
            <div className="flex justify-between my-4">
              <Button
                disabled={areBtnsDisabled}
                isLoading={isLoadingUpscaleAndOverride}
                onClick={() => onBtnClick(true)}
                variant="button--secondary">
                Upscale & Overwrite
              </Button>
              <Button
                disabled={areBtnsDisabled}
                isLoading={isLoadingUpscaleAndDownload}
                onClick={() => onBtnClick()}>
                Upscale & Download
              </Button>
            </div>
          </div>
        </section>
      </CustomDialog>
    </div>
  );
};
